module.exports = __webpack_public_path__ + "media/src/img/footer-deco-rh-3c543c354c2e62b211fa907ca55b1f5a.png";